import React from "react";
import { Link, useLocation } from "react-router-dom";
import ProfileListingPageLayout from "../components/ProfileListingPageLayout";
import ProfileCard from "../components/ProfileCard";
import profilesData from "../data/profiles.json";
import Disclaimer from "../components/Disclaimer";
// import Carousel from "../components/Carousel";
// import carouselImages from "../data/carouselImages";

const IR: React.FC = () => {
  const location = useLocation();
  const activeTab = location.pathname.includes("reverb") ? "reverb" : "cab";

  const cabDescription = (
    <p className="opacity-70 mt-4 text-xl lg:text-xl">
      <b>Elevate Your Tone with Premium Cabinet Impulse Responses (Cab IRs).</b>{" "}
      Discover our collection of meticulously captured guitar cabinet impulse
      responses, designed to bring the authentic response and character of
      legendary cabinets to your digital rig.
    </p>
  );

  const reverbDescription = (
    <p className="opacity-70 mt-4 text-xl lg:text-xl">
      <b>
        Immerse Your Sound in Premium Reverb Impulse Responses (Reverb IRs).
      </b>{" "}
      Explore our collection of high-fidelity reverb impulse responses, captured
      from legendary hardware processors, iconic acoustic spaces, and unique
      ambient locations.
    </p>
  );

  const reverbdataProfile = profilesData.find(
    (p) => p.id === "reverbdata-portuguese-binaural-ir",
  );

  const pwcReverbProfile = profilesData.find(
    (p) => p.id === "pwc-basic-reverb-ir",
  );

  return (
    <>
      {/* {activeTab === "cab" && <Carousel images={carouselImages} className=" max-h-1/6" />} */}
      {/* {activeTab === "reverb" && <Carousel images={carouselImages} className=" max-h-1/6" />} */}

      <div className="container mx-auto pt-8 pb-4 text-center">
        <div className="inline-flex rounded-full bg-white/5 p-1.5 border border-white/10">
          <Link
            to="/cab-ir"
            className={`px-6 py-2.5 rounded-full font-semibold transition-all duration-300 ${
              activeTab === "cab"
                ? "bg-blue-600 text-white shadow-lg shadow-blue-500/20"
                : "text-gray-400 hover:text-white"
            }`}
          >
            Cabinet IRs
          </Link>
          <Link
            to="/reverb-ir"
            className={`px-6 py-2.5 rounded-full font-semibold transition-all duration-300 ${
              activeTab === "reverb"
                ? "bg-blue-600 text-white shadow-lg shadow-blue-500/20"
                : "text-gray-400 hover:text-white"
            }`}
          >
            Reverb IRs
          </Link>
        </div>
      </div>

      {activeTab === "cab" ? (
        <ProfileListingPageLayout
          pageTitle="Cabinet Impulse Responses"
          pageDescription={cabDescription}
          profileTypeFilter="cab-ir"
          titleGradientClass="gradient-text-tonex"
        />
      ) : (
        <>
          {/* Header Section */}
          <div className="container mx-auto p-8 text-white max-w-[1280px]">
            <section className="py-5 text-center flex flex-col items-center">
              <h1 className="text-4xl md:text-6xl lg:text-8xl font-bold mb-0 lg:mb-16 gradient-text-tonex">
                Reverb Impulse Responses
              </h1>
              {reverbDescription}

              {/* Plugin Link Info Banner */}
              <div className="mt-8 flex flex-col md:flex-row items-center justify-center gap-6 max-w-3xl bg-white bg-opacity-[3%] border border-white/5 rounded-2xl p-6 shadow-xl text-left">
                <img
                  src="/images/plugins/pwc_nam_skin_iic/nam_pedals_win.jpg"
                  alt="PWC Skin II on Macbook"
                  className="w-auto h-72 object-contain flex-shrink-0"
                />
                <div>
                  <p className="text-gray-300 text-sm md:text-base mb-3 leading-relaxed">
                    All our reverb impulse responses are optimized for, and can
                    be loaded directly into, the Convolution Reverb engine of
                    our flagship plugin,
                    <b className="text-white"> PWC Skin II</b>{" "}
                    <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gradient-to-r from-cyan-400 to-blue-500 text-gray-950 text-[10px] font-black uppercase tracking-wider shadow-[0_0_8px_rgba(34,211,238,0.4)] ml-1">
                      NEW
                    </span>
                    .
                  </p>
                  <Link
                    to="/plugins/pwcskinv2"
                    className="px-6 py-3 mt-8 bg-white/5 hover:bg-white/10 text-white font-semibold rounded-xl border border-white/10 hover:border-white/20 transition-all duration-200 text-sm md:text-base inline-flex items-center gap-2"
                  >
                    Learn more
                  </Link>
                </div>
              </div>
            </section>
          </div>
          {/* PWC Reverbs Section (No Container Wrapper) */}
          <div className="container mx-auto px-8 max-w-[1280px] pb-16 mt-6 text-white border-b border-white/10">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-center">
              <div className="lg:col-span-7 flex flex-col justify-center text-left">
                <span className="uppercase tracking-[0.2em] text-xs font-bold text-blue-400 mb-3 block">
                  Free Starter Pack
                </span>
                <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6 leading-tight">
                  PWC Basic Reverbs
                </h2>
                <p className="text-gray-300 text-base md:text-lg leading-relaxed mb-6">
                  Get started with our essential, pre-mixed <u>stereo</u> reverb
                  impulse responses. This collection is specifically compiled to
                  bring high-quality studio environments to your guitar modeling
                  and production setups.
                </p>
                <p className="text-gray-300 text-base md:text-lg leading-relaxed mb-8">
                  Includes three classical reverb types: a spring reverb for
                  vintage tube amp drip, a chamber reverb for rich, warm
                  acoustic spaces, and a plate reverb for bright, dense studio
                  decay. Free to download and compatible with any convolution
                  engine.
                </p>
              </div>

              <div className="lg:col-span-5 flex flex-col items-center gap-8">
                <div className="w-full max-w-[360px] bg-white bg-opacity-[3%] border border-white/5 rounded-2xl p-4 shadow-xl">
                  {pwcReverbProfile && (
                    <ProfileCard profile={pwcReverbProfile} />
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* REVERBDATA Info Section (No Container Wrapper) */}
          <div className="container mx-auto px-8 max-w-[1280px] pb-24 mt-16 text-white">
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-center">
              <div className="lg:col-span-7 flex flex-col justify-center text-left">
                <span className="uppercase tracking-[0.2em] text-xs font-bold text-blue-400 mb-3 block">
                  Free Convolution Reverbs
                </span>
                <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6 leading-tight">
                  REVERBDATA Project
                </h2>
                <p className="text-gray-300 text-base md:text-lg leading-relaxed mb-6">
                  REVERBDATA is a dedicated acoustic heritage project preserving
                  the unique spatial responses of architecturally and culturally
                  significant Portuguese spaces. Through meticulous
                  high-resolution recordings, they capture the sound of concert
                  halls, cathedrals, and historical chambers.
                </p>
                <p className="text-gray-300 text-base md:text-lg leading-relaxed mb-8">
                  We have selected and converted 7 binaural stereo Impulse
                  Responses (IRs) from this open-source dataset into an
                  easy-to-load package.
                </p>
                <div className="flex flex-wrap gap-4">
                  <a
                    href="https://reverbdata.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-6 py-3 bg-white/5 hover:bg-white/10 text-white font-semibold rounded-xl border border-white/10 hover:border-white/20 transition-all duration-200 text-sm md:text-base inline-flex items-center gap-2"
                  >
                    Visit REVERBDATA Website
                  </a>
                  <a
                    href="https://creativecommons.org/licenses/by-nc-sa/4.0/?ref=chooser-v1"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-6 py-3 bg-white/5 hover:bg-white/10 text-white font-semibold rounded-xl border border-white/10 hover:border-white/20 transition-all duration-200 text-sm md:text-base inline-flex items-center gap-2"
                  >
                    CC BY-NC-SA 4.0 License
                  </a>
                </div>
              </div>

              <div className="lg:col-span-5 flex flex-col items-center gap-8">
                <div className="w-full max-w-[360px] bg-white bg-opacity-[3%] border border-white/5 rounded-2xl p-4 shadow-xl">
                  {reverbdataProfile && (
                    <ProfileCard profile={reverbdataProfile} />
                  )}
                </div>
              </div>
            </div>{" "}
            <Disclaimer />
          </div>{" "}
        </>
      )}
    </>
  );
};

export default IR;
